// Convenciones:
// - "n/a" = no confirmado / no disponible.
// - date: ISO (YYYY-MM-DD). Formatear con formatDate() al mostrar.
// - status: "Reclamado por el atacante" | "Muestra analizada por terceros" | "Confirmado por la organización" | "n/a"
// - dataSize: siempre es una cifra declarada por el atacante, salvo que se indique lo contrario.
// - sources: solo URLs que fueron encontradas y leídas. [] = sin fuentes verificadas todavía.

export const incidentsData = [
  {
    title: "Blanco & Etcheverry",
    date: "2026-09-04",
    group: "Gunra",
    attackType: "Ransomware",
    status: "Reclamado por el atacante",
    dataSize: "300 GB",
    sector: "Servicios legales",
    description: [
      "El grupo de ransomware Gunra anunció a la firma de abogados uruguaya Blanco & Etcheverry como víctima en su sitio de filtraciones y afirma haber exfiltrado 300 GB de datos bajo la modalidad de doble extorsión.",
      "El ataque no ha sido confirmado por la firma."
    ],
    tags: ["Ransomware", "Servicios"],
    sources: [
      { label: "Rio Times", url: "https://www.riotimesonline.com/gunra-ransomware-uruguay-firms-2026/" },
      { label: "SOCRadar", url: "https://socradar.io/free-tools/ransomware-intelligence/victims/blanco-etcheverry-gunra-db3424ca" },
      { label: "Ransomware.live", url: "https://ransomware.live/id/QmxhbmNvICYgRXRjaGV2ZXJyeUBndW5yYQ" },
    ],
    thumb: "4765432456789075432456782.webp",
  },
  {
    title: "Integraduanas",
    date: "2026-08-19",
    group: "Qilin",
    attackType: "Ransomware",
    status: "Reclamado por el atacante",
    dataSize: "n/a",
    sector: "Logística y comercio exterior",
    description: [
      "El grupo de ransomware Qilin anunció a Integraduanas como víctima en su sitio de filtraciones.",
      "Un informe de SOCRadar identifica credenciales corporativas expuestas por malware de tipo infostealer, pero señala que eso por sí solo no confirma una intrusión en la empresa. No se encontró una confirmación pública del ataque por parte de la empresa."
    ],
    tags: ["Ransomware", "Servicios"],
    sources: [
      { label: "SOCRadar", url: "https://socradar.io/data-breach/integroaduanas-qilin-ransomware-2026/" },
      { label: "Ransomware.live", url: "https://ransomware.live/id/SW50ZWdyYWR1YW5hc0BxaWxpbg" },
    ],
    thumb: "4765432456789075436456782.png",
  },
  {
    title: "Vigilia",
    date: "2026-08-28",
    group: "Global",
    attackType: "Ransomware",
    status: "Reclamado por el atacante",
    dataSize: "n/a",
    sector: "Salud",
    description: [
      "El grupo de ransomware Global anunció a Vigilia, empresa uruguaya de servicios de asistencia y cuidado de personas, como víctima en su sitio de filtraciones. El grupo amenazó con publicar la información completa si un representante de la empresa no se comunica con ellos. El ataque se estima ocurrido el 06/08/2026.",
      "Ransomware.live registra además actividad de infostealer asociada al dominio de la empresa (3 empleados con credenciales comprometidas, según HudsonRock), sin que ninguna fuente establezca una relación con este ataque. La empresa no ha confirmado el incidente."
    ],
    tags: ["Ransomware", "Salud"],
    sources: [
      { label: "DeXpose", url: "https://www.dexpose.io/global-ransomware-group-compromises-vigilia-in-uruguay/" },
      { label: "Ransomware.live", url: "https://ransomware.live/id/VmlnaWxpYUBnbG9iYWw=" },
      { label: "GalaxyWarden", url: "https://www.galaxywarden.com/blog/breach/vigilia-global-2026-08" },
    ],
    thumb: "no-image.jpg",
  },
  {
    title: "Automóvil Club del Uruguay",
    date: "2026-07-10",
    group: "Deadlock",
    attackType: "Ransomware",
    status: "Reclamado por el atacante",
    dataSize: "n/a",
    sector: "Asociación civil sin fines de lucro",
    description: [
      "El grupo de ransomware Deadlock anunció al Automóvil Club del Uruguay (ACU), organización sin fines de lucro, como víctima en su sitio de filtraciones.",
      "El ataque no ha sido confirmado por la institución.",
    ],
    tags: ["Ransomware", "Servicios"],
    sources: [
      { label: "Ransomware.live", url: "https://www.ransomware.live/id/QUNVIC0gVGhlIEF1dG9tb2JpbGUgQ2x1YiBvZiBVcnVndWF5QERlYWRsb2Nr" },
    ],
    thumb: "4265432456789015432456789.png",
  },
  {
    title: "Hospital de Clínicas, INISA y otros sitios web",
    date: "2026-07-05",
    group: "Antonkill",
    attackType: "Defacement",
    status: "Confirmado por la organización",
    dataSize: "n/a",
    sector: "Salud / Gobierno",
    description: [
      "Una campaña automatizada de defacement atribuida al actor Antonkill alteró los sitios web del Hospital de Clínicas, INISA y la Sociedad Uruguaya de Gerontología, entre otros.",
      "El ataque no fue dirigido y aprovechó una vulnerabilidad de Joomla que no requería autenticación, permitiendo al atacante agregarse como usuario autorizado. El sitio del Hospital de Clínicas permaneció caído al menos una semana. Según el hospital, el ataque afectó solo páginas informativas y no comprometió datos personales ni historias clínicas.",
    ],
    tags: ["Defacement", "Salud", "Gobierno"],
    sources: [
      { label: "El Observador", url: "https://www.elobservador.com.uy/ciencia-y-tecnologia/ciberataque-la-web-del-hospital-clinicas-esta-caida-hace-una-semana-n6050229" },
      { label: "El Observador (cómo ocurrió)", url: "https://www.elobservador.com.uy/ciencia-y-tecnologia/como-la-web-del-hospital-clinicas-y-las-otras-instituciones-uruguayas-fue-victima-un-ataque-masivo-internet-n6050250" },
      { label: "Subrayado", url: "https://www.subrayado.com.uy/web-del-clinicas-fue-hackeada-y-agesic-trabaja-resolver-problema-delincuentes-no-accedieron-datos-personales-n1012503" },
      { label: "Telenoche", url: "https://www.telenoche.com.uy/nacionales/hackearon-las-paginas-web-del-hospital-clinicas-el-inisa-y-otras-instituciones-n5401912" },
    ],
    thumb: "4265432456189075432456782.jpeg",
  },
  {
    title: "Yuditec S.A.",
    date: "2026-06-30",
    group: "Gunra",
    attackType: "Ransomware",
    status: "Reclamado por el atacante",
    dataSize: "30 GB",
    sector: "Manufactura",
    description: [
      "El grupo de ransomware Gunra anunció a Yuditec S.A., empresa uruguaya de diseño y fabricación de interiores comerciales, como víctima en su sitio de filtraciones.",
      "Según el propio grupo, tendría en su poder 30 GB de información. El ataque no ha sido confirmado por la empresa.",
    ],
    tags: ["Ransomware", "Manufactura", "Diseño"],
    sources: [
      { label: "Ransomware.live", url: "https://www.ransomware.live/id/WXVkaXRlYyBTLkEuQGd1bnJh" },
      { label: "Rio Times", url: "https://www.riotimesonline.com/gunra-ransomware-uruguay-firms-2026/" },
    ],
    thumb: "no-image.jpg",
  },
  {
    title: "Suárez & Clavera",
    date: "2026-06-12",
    group: "Gunra",
    attackType: "Ransomware",
    status: "Reclamado por el atacante",
    dataSize: "n/a",
    sector: "Servicios profesionales",
    description: [
      "El grupo de ransomware Gunra anunció a Suárez & Clavera como víctima en su sitio de filtraciones.",
      "El ataque no ha sido confirmado por la empresa.",
    ],
    tags: ["Ransomware", "Servicios"],
    sources: [
      { label: "Ransomware.live", url: "https://ransomware.live/id/U3XDoXJleiZDbGF2ZXJhQGd1bnJh" },
      { label: "SOCRadar (perfil de Gunra)", url: "https://socradar.io/free-tools/ransomware-intelligence/groups/gunra" },
    ],
    thumb: "no-image.jpg",
  },
  {
    title: "Dobarro & Pichel",
    date: "2026-06-09",
    group: "LockBit 5.0",
    attackType: "Ransomware",
    status: "Reclamado por el atacante",
    dataSize: "n/a",
    sector: "Climatización",
    description: [
      "LockBit 5.0 anunció a Dobarro & Pichel, empresa uruguaya dedicada a la venta y mantenimiento de equipos de climatización y calefacción.",
      "El grupo amenazó con publicar la información completa si un representante de la empresa no se comunica con ellos.",
    ],
    tags: ["Ransomware", "Climatización", "Comercio"],
    sources: [
      { label: "DeXpose", url: "https://www.dexpose.io/lockbit-5-0-targets-dobarro-pichel-in-uruguay/" },
      { label: "Ransomware.live", url: "https://ransomware.live/id/ZG9iYXJyby5jb20udXlAbG9ja2JpdDU=" },
    ],
    thumb: "8765432466789075432456789.png",
  },
  {
    title: "GuiaEmpresas",
    date: "2026-06-02",
    group: "n/a",
    attackType: "Venta de datos",
    status: "Reclamado por el atacante",
    dataSize: "n/a",
    sector: "n/a",
    description: [
      "Un actor de amenazas ofrece a la venta una base de datos con unos 184.000 registros que atribuye a GuiaEmpresas Uruguay.",
      "Según el vendedor, incluye datos de empresas (nombres, correos, teléfonos, direcciones, identificadores fiscales, cantidad de empleados y facturación), además de historial de órdenes, estado de pagos y tickets de soporte. Compartió una muestra; la autenticidad del total no está confirmada.",
    ],
    tags: ["Venta de datos", "Empresas"],
    sources: [
      { label: "Dark Web Intelligence (X)", url: "https://x.com/DailyDarkWeb/status/2061092373631799345" },
    ],
    thumb: "3265432456789015432456789.jpeg",
  },
  {
    title: "Ticket Antel",
    date: "2026-05-15",
    group: "DeadPresidents",
    attackType: "Venta de datos",
    status: "Muestra analizada por terceros",
    dataSize: "1 GB",
    sector: "Venta de entradas (Antel)",
    description: [
      "DeadPresidents anunció a Tickantel, la plataforma de venta de entradas de Antel, y puso a la venta 1 GB de información. La filtración es consecuencia del ataque a HG S.A.: según los reportes, los atacantes se movieron desde ese acceso hacia el servidor de desarrollo de Tickantel.",
      "El material incluiría plantillas FTL (entre ellas las de Club Atlético Peñarol), versiones de aplicaciones y capturas de acceso al servidor de desarrollo. Según los medios, no se reportaron datos de tarjetas ni compras comprometidos.",
    ],
    tags: ["Venta de datos", "Tecnología", "Telecomunicaciones"],
    sources: [
      { label: "El Observador", url: "https://www.elobservador.com.uy/ciencia-y-tecnologia/ciberdelincuentes-filtraron-1-gb-informacion-servidores-tickantel-como-afecta-los-usuarios-n6044143" },
      { label: "Montevideo Portal", url: "https://www.montevideo.com.uy/Ciencia-y-Tecnologia/Hackers-advierten-por-ataque-a-servidores-de-TickAntel-que-se-sabe-hasta-ahora-uc962126" },
      { label: "Cadena del Mar", url: "https://cadenadelmar.uy/nacional/ciberataque-tickantel-informacion-interna-y-archivos-ligados-a-penarol-19880" },
    ],
    thumb: "8765432456789075432456789.jpg",
  },
  {
    title: "HG S.A",
    date: "2026-05-12",
    group: "DeadPresidents",
    attackType: "Venta de datos",
    status: "Muestra analizada por terceros",
    dataSize: "12 GB",
    sector: "Tecnología",
    description: [
      "DeadPresidents anunció a HG S.A., subsidiaria de Antel dedicada al desarrollo de sitios web, aplicaciones y portales para organismos del Estado, y puso a la venta unos 12 GB de datos.",
      "Incluiría credenciales de empleados, bases de datos, código fuente de sitios y aplicaciones Android de sus clientes, y acceso a servidores. El acceso inicial habría sido comprado a un Initial Access Broker. HG activó un monitoreo reforzado.",
    ],
    tags: ["Venta de datos", "Gobierno", "Tecnología"],
    sources: [
      { label: "El Observador", url: "https://www.elobservador.com.uy/ciberdelincuentes-filtran-accesos-servidores-una-empresa-antel-n6043757" },
      { label: "LARED21", url: "https://www.lr21.com.uy/tecnologia/1494801-deadpresidents-hackers-robo-datos-subsidiaria-antel" },
    ],
    thumb: "no-image.jpg",
  },
  {
    title: "Junta Departamental de Florida",
    date: "2026-03-07",
    group: "DeadPresidents",
    attackType: "Defacement",
    status: "Confirmado por la organización",
    dataSize: "n/a",
    sector: "Gobierno",
    description: [
      "DeadPresidents (ex ExPresidents) modificó el sitio web de la Junta Departamental de Florida con un mensaje que afirma haber cifrado el servidor con su propio ransomware. Presentaron a la Junta como su \"primera víctima\".",
      "Aseguran tener información de contribuyentes, recibos de sueldo de funcionarios y código de sitios y aplicaciones Tomcat. Fijaron el 20 de marzo como fecha límite para negociar."
    ],
    tags: ["Ransomware", "Gobierno"],
    sources: [
      { label: "El Observador", url: "https://www.elobservador.com.uy/ciencia-y-tecnologia/ciberdelincuentes-volvieron-atacar-un-sitio-web-del-estado-luego-varios-meses-n6036652" },
      { label: "Telenoche", url: "https://www.telenoche.com.uy/sociedad/hackeo-la-junta-florida-grupo-hacker-afirma-tener-archivos-del-organismo-y-propone-negociar-un-rescate-n5396850" },
    ],
    thumb: "8765432456789075432456782.jpeg",
  },
  {
    title: "Fucerep",
    date: "2025-11-21",
    group: "RansomHouse",
    attackType: "Ransomware",
    status: "Reclamado por el atacante",
    dataSize: "n/a",
    sector: "Finanzas",
    description: [
      "El grupo de ransomware RansomHouse anunció a Fucerep, cooperativa de ahorro y crédito dirigida a personas y empresas, como víctima en su sitio de filtraciones.",
      "El ataque se estima ocurrido el 14/10/2025.",
    ],
    tags: ["Ransomware", "Finanzas"],
    sources: [
      { label: "DeXpose", url: "https://www.dexpose.io/?p=17614" },
      { label: "Ransomware.live", url: "https://www.ransomware.live/id/RnVjZXJlcEByYW5zb21ob3VzZQ==" },
      { label: "Breachsense", url: "https://www.breachsense.com/breaches/fucerep-data-breach/" },
    ],
    thumb: "476543200456789075432456782.png",
  },
  {
    title: "Banco Hipotecario del Uruguay",
    date: "2025-10-03",
    group: "Crypto24",
    attackType: "Ransomware",
    status: "Confirmado por la organización",
    dataSize: "700 GB",
    sector: "Finanzas / Gobierno",
    description: [
      "El grupo de ransomware Crypto24 reivindicó un ataque al Banco Hipotecario del Uruguay (BHU) y afirma haber exfiltrado más de 700 GB de información sensible, incluyendo datos personales de clientes, documentación financiera y contable, contratos y títulos de propiedad.",
      "El BHU informó de un incidente de ciberseguridad detectado el 1 de octubre y dio de baja su red institucional. Según El Observador, tras vencer el plazo de diez días el grupo publicó parte de los archivos; el banco no se pronunció públicamente sobre la autenticidad de esa información.",
    ],
    tags: ["Ransomware", "Finanzas", "Gobierno"],
    sources: [
      { label: "El Observador (comunicado del BHU)", url: "https://www.elobservador.com.uy/ciencia-y-tecnologia/ciberataque-al-bhu-la-web-continua-caida-seis-dias-inactividad-y-esto-informa-el-banco-n6019770" },
      { label: "El Observador (publicación de datos)", url: "https://www.elobservador.com.uy/ciencia-y-tecnologia/ciberataque-al-bhu-los-criminales-cumplieron-su-amenaza-y-filtraron-700-gb-informacion-n6020569" },
      { label: "Telenoche", url: "https://www.telenoche.com.uy/ciencia-y-tecnologia/hackers-realizaron-un-ciberataque-al-banco-hipotecario-y-robaron-300-y-700-gigas-informacion-n5390540" },
      { label: "Subrayado", url: "https://www.subrayado.com.uy/ciberdelincuentes-atacaron-al-bhu-crypto24-libero-datos-usuarios-la-institucion-y-exigian-pagos-n990094" },
    ],
    thumb: "8765432456789075432456089.jpeg",
  },
  {
    title: "Ceres",
    date: "2025-09-09",
    group: "The Gentlemen",
    attackType: "Ransomware",
    status: "Reclamado por el atacante",
    dataSize: "n/a",
    sector: "Investigación y políticas públicas",
    description: [
      "El grupo de ransomware The Gentlemen anunció a CERES (Centro de Estudios de la Realidad Económica y Social), centro de investigación independiente y sin fines de lucro, como víctima en su sitio de filtraciones.",
      "El ataque no ha sido confirmado por la organización.",
    ],
    tags: ["Ransomware", "Servicios"],
    sources: [
      { label: "Ransomware.live", url: "https://www.ransomware.live/id/Q2VyZXNAdGhlZ2VudGxlbWVu" },
      { label: "Breachsense", url: "https://www.breachsense.com/breaches/ceres-uruguay-data-breach/" },
    ],
    thumb: "4765432456889075488456782.png",
  },
  {
    title: "TV Ciudad",
    date: "2025-04-24",
    group: "Gov.eth",
    attackType: "Defacement",
    status: "Confirmado por la organización",
    dataSize: "n/a",
    sector: "Medios",
    description: [
      "El hacker Gov.eth, presunto autor, alteró el sitio web de TV Ciudad, canal de la Intendencia de Montevideo, publicando imágenes falsas generadas con IA de autoridades políticas y un mensaje amenazante.",
      "El canal denunció el hecho ante Delitos Informáticos de la Jefatura de Policía de Montevideo y restituyó el sitio.",
    ],
    tags: ["Defacement", "Medios"],
    sources: [
      { label: "Montevideo Portal", url: "https://www.montevideo.com.uy/Noticias/Hackearon-web-de-TV-Ciudad-publicaron-imagenes-de-politicos-semidesnudos-y-un-mensaje-uc921824" },
      { label: "Telenoche", url: "https://www.telenoche.com.uy/nacionales/hackearon-la-web-tv-ciudad-y-difundieron-imagenes-falsas-orsi-cosse-y-lema-no-vamos-parar-n5383363" },
      { label: "Caras y Caretas", url: "https://www.carasycaretas.com.uy/sociedad/tv-ciudad-denuncio-un-ciberataque-su-sitio-web-no-vamos-parar-n83779" },
    ],
    thumb: "no-image.jpg",
  },
  {
    title: "Dinacia",
    date: "2025-03-17",
    group: "LaPampaLeaks, BogotaLeaks y Uruguayo1337",
    attackType: "Defacement",
    status: "Confirmado por la organización",
    dataSize: "n/a",
    sector: "Gobierno",
    description: [
      "Los grupos LaPampaLeaks, BogotaLeaks y Uruguayo1337 adulteraron el sitio web de la Dirección Nacional de Aviación Civil e Infraestructura Aeronáutica (Dinacia) mediante un envenenamiento de DNS sobre los servidores de Agesic.",
      "Publicaron la foto y el teléfono personal del presidente Yamandú Orsi, además de una imagen de un jerarca de Agesic. El sitio fue restaurado el mismo día. Un joven fue imputado y enviado a prisión preventiva por el hecho.",
    ],
    tags: ["Defacement", "Gobierno"],
    sources: [
      { label: "El Observador (DNS)", url: "https://www.elobservador.com.uy/ciencia-y-tecnologia/hackeo-la-dinacia-como-envenenaron-servidores-del-estado-adulterar-el-sitio-web-n5990048" },
      { label: "El Observador (imputado)", url: "https://www.elobservador.com.uy/ciencia-y-tecnologia/paginas-del-estado-estuvieron-caidas-este-domingo-y-un-grupo-hackers-se-atribuyo-la-autoria-un-ciberataque-n5992074" },
      { label: "LARED21", url: "https://www.lr21.com.uy/politica/1482096-hackers-ataque-dinacia-intencionalidad-politica" },
    ],
    thumb: "4265432456789075432456789.png",
  },
  {
    title: "Nicatel S.A.",
    date: "2025-01-13",
    group: "LockBit 3.0",
    attackType: "Ransomware",
    status: "Reclamado por el atacante",
    dataSize: "n/a",
    sector: "Comercio (distribución de electrónica)",
    description: [
      "LockBit 3.0 publicó a Nicatel S.A., distribuidor oficial de celulares y accesorios Samsung desde 2007 y de Havit desde 2018, como nueva víctima en su sitio de filtraciones.",
      "El ataque se estima ocurrido el 21/12/2024.",
    ],
    tags: ["Ransomware", "Comercio"],
    sources: [
      { label: "Ransomware.live", url: "https://ransomware.live/id/bmljYXRlbC5jb20udXlAbG9ja2JpdDM" },
    ],
    thumb: "4065432456789075437656782.png",
  },
  {
    title: "INDA",
    date: "2024-12-15",
    group: "Dragon Ransomware",
    attackType: "Ransomware",
    status: "Reclamado por el atacante",
    dataSize: "n/a",
    sector: "Educación",
    description: [
      "El grupo Dragon Ransomware afirmó haber cifrado los archivos de INDA, instituto que ofrece cursos en línea.",
      "El ataque se estima ocurrido el 29/11/2024.",
    ],
    tags: ["Ransomware", "Educación"],
    sources: [
      { label: "Ransomware.live", url: "https://ransomware.live/id/aW5kYS5lZHUudXlAZHJhZ29ucmFuc29td2FyZQ" },
    ],
    thumb: "4765432456789075432456982.png",
  },
  {
    title: "Supermercados El Dorado",
    date: "2024-11-14",
    group: "Akira",
    attackType: "Ransomware",
    status: "Reclamado por el atacante",
    dataSize: "n/a",
    sector: "Comercio",
    description: [
      "El grupo de ransomware Akira anunció a El Dorado, cadena de tiendas y supermercados familiar de capital 100% uruguayo, como víctima en su sitio de filtraciones.",
      "El ataque se estima ocurrido el 25/07/2024.",
    ],
    tags: ["Ransomware", "Comercio"],
    sources: [
      { label: "Ransomware.live", url: "https://ransomware.live/id/RWwgRG9yYWRvIFN0b3JlcyBhbmQgU3VwZXJtYXJrZXRzQGFraXJh" },
    ],
    thumb: "no-image.jpg",
  },
  {
    title: "Botiga",
    date: "2024-11-08",
    group: "APT73",
    attackType: "Ransomware",
    status: "Reclamado por el atacante",
    dataSize: "n/a",
    sector: "Comercio",
    description: [
      "El grupo de ransomware APT73 anunció a Botiga, tienda en línea uruguaya, como víctima en su sitio de filtraciones.",
      "El ataque no ha sido confirmado por la empresa.",
    ],
    tags: ["Ransomware", "Comercio"],
    sources: [
      { label: "Ransomware.live", url: "https://ransomware.live/id/d3d3LmJvdGlnYS5jb20udXlAYXB0NzM" },
    ],
    thumb: "4765432456789075488456782.png",
  },
  {
    title: "GEOCOM",
    date: "2023-11-06",
    group: "Cactus",
    attackType: "Ransomware",
    status: "Reclamado por el atacante",
    dataSize: "n/a",
    sector: "Tecnología",
    description: [
      "El grupo de ransomware Cactus anunció a GEOCOM Uruguay S.A., proveedora de soluciones de tecnología de la información, como víctima en su sitio de filtraciones.",
      "El ataque no ha sido confirmado por la empresa.",
    ],
    tags: ["Ransomware", "Tecnología"],
    sources: [
      { label: "Ransomware.live", url: "https://ransomware.live/id/R0VPQ09NQGNhY3R1cw" },
    ],
    thumb: "no-image.jpg",
  },
  {
    title: "ETSI",
    date: "2023-09-14",
    group: "Knight",
    attackType: "Ransomware",
    status: "Reclamado por el atacante",
    dataSize: "n/a",
    sector: "n/a",
    description: [
      "El grupo de ransomware Knight anunció a ETSI (etsi.uy) como víctima en su sitio de filtraciones.",
      "Según el grupo, la víctima se negó a negociar ni a realizar esfuerzos para pagar, por lo que los datos serían publicados.",
    ],
    tags: ["Ransomware", "Empresas"],
    sources: [
      { label: "Ransomware.live", url: "https://ransomware.live/id/ZXRzaS51eUBrbmlnaHQ" },
    ],
    thumb: "no-image.jpg",
  },
  {
    title: "Guyer & Regules",
    date: "2023-08-31",
    group: "LockBit 3.0",
    attackType: "Ransomware",
    status: "Muestra analizada por terceros",
    dataSize: "1 TB",
    sector: "Servicios legales",
    description: [
      "LockBit 3.0 anunció a la firma de abogados Guyer & Regules como víctima en su sitio de filtraciones, afirma haber obtenido 1 TB de información y pidió US$ 300.000 de rescate.",
      "El grupo afirmó haber infiltrado la red de la firma aprovechando deficiencias de su personal de TI. El Observador comprobó que la filtración incluye pasaportes, recibos de sueldo de terceras empresas y acuerdos de confidencialidad con clientes. La firma informó que detectó un intento de ciberataque y presentó denuncias.",
    ],
    tags: ["Ransomware", "Servicios"],
    sources: [
      { label: "El Observador", url: "https://www.elobservador.com.uy/nota/hackearon-informacion-del-estudio-juridico-guyer-regules-y-piden-us-300-000-de-rescate-202391131453" },
      { label: "Ransomware.live", url: "https://ransomware.live/id/Z3V5ZXIuY29tLnV5QGxvY2tiaXQz" },
    ],
    thumb: "4265432456789075432456782.jpg",
  },
  {
    title: "FIX SCR",
    date: "2023-05-30",
    group: "LockBit 3.0",
    attackType: "Ransomware",
    status: "Reclamado por el atacante",
    dataSize: "n/a",
    sector: "Finanzas",
    description: [
      "LockBit 3.0 anunció a FIX SCR (fixscr.com), calificadora de riesgo regional y filial local de Fitch Group en Argentina, Uruguay y Paraguay, como víctima en su sitio de filtraciones.",
      "Los trackers asocian el caso a Uruguay, pero no se identificó qué filial o sede fue afectada. El ataque no ha sido confirmado por la empresa.",
    ],
    tags: ["Ransomware", "Finanzas"],
    sources: [
      { label: "Ransomware.live", url: "https://www.ransomware.live/id/Zml4c2NyLmNvbUBsb2NrYml0Mw==" },
    ],
    thumb: "4765432456789075437656782.png",
  },
];